import React from 'react';

type GenericListItemProps = {
  compact: boolean;
  compactAccentColor: string;
  compactMain: React.ReactNode;
  compactActions: React.ReactNode;
  fullBadge?: React.ReactNode;
  fullMain: React.ReactNode;
  fullActions: React.ReactNode;
};

const GenericListItem: React.FC<GenericListItemProps> = ({
  compact,
  compactAccentColor,
  compactMain,
  compactActions,
  fullBadge,
  fullMain,
  fullActions,
}) => {
  if (compact) {
    return (
      <div
        style={{
          border: '1px solid #e2e8f0',
          borderLeft: `4px solid ${compactAccentColor}`,
          borderRadius: 8,
          padding: '8px 10px',
          background: '#fff',
          boxShadow: '0 1px 3px rgba(15,23,42,0.05)',
          display: 'flex',
          alignItems: 'center',
          gap: 8,
        }}
      >
        <div style={{ flex: 1, minWidth: 0 }}>{compactMain}</div>
        <div style={{ display: 'flex', gap: 3, flexShrink: 0 }}>{compactActions}</div>
      </div>
    );
  }

  return (
    <div
      style={{
        border: '1px solid #e2e8f0',
        borderRadius: 10,
        padding: 16,
        background: '#fff',
        boxShadow: '0 1px 4px rgba(15,23,42,0.05)',
        position: 'relative',
      }}
    >
      {fullBadge}
      <div style={{ minWidth: 0, paddingRight: 90 }}>{fullMain}</div>
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', justifyContent: 'flex-end', marginTop: 14 }}>
        {fullActions}
      </div>
    </div>
  );
};

export default GenericListItem;

